"use client";

import { useState, useEffect, useCallback } from "react";

export function useAccordionMemory(
  key: string,
  defaultValue: string[]
): [string[], (value: string[]) => void] {
  const [value, setValue] = useState<string[]>(defaultValue);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(key);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          setValue(parsed);
        }
      }
    } catch {
    }
    setHydrated(true);
  }, [key]);

  const setAndPersist = useCallback(
    (next: string[]) => {
      setValue(next);
      try {
        localStorage.setItem(key, JSON.stringify(next));
      } catch {
      }
    },
    [key]
  );

  return [hydrated ? value : defaultValue, setAndPersist];
}
